import React from "react";
import i18n from "@euroland/libs/locale/i18n";
import { TOOL_TEMPLATE, DATA_LISTS} from "../../constant/common";
import { useInstrument } from "../../hooks/useInstruments";
import {
  useCompanySettings,
  useTemplateSetting,
  useFormatSetting,
} from "../../hooks/useCompanySettings";
// import { TableData } from "@euroland/react";
import { TableData } from "@euroland/react-table";

import { ProfileMarketTable, OtherMarketInfoTable } from "../TickerTable";
import {TableHeaderFn,TableBodyDataFn} from "../TableDataCreate";

const createTableData = ({ instrument, data, template}) => {
  let header = {}, header2 = {}, body = [], body2 = [];
  let getdata = data;
  let title = {};
  let instruments = instrument;
  let tableBody = [];

  function headerBodyData(datas,body){
    let headerData = {};
    let bodyData = [];
    if(body === false){
      datas.dataItems.forEach((item) => {
        let items = DATA_LISTS[item];
        headerData = TableHeaderFn(items, headerData);
      });
      return headerData ;
    }
    if(body === true) {
      datas.dataItems.forEach((item) => {
        let items = DATA_LISTS[item];
        bodyData[0] = TableBodyDataFn(instruments,items, bodyData[0], "right",template);
      });
      return bodyData;
    }
  }
  switch (template) {
    case TOOL_TEMPLATE.quadrata:
          getdata.forEach((datas, i) => {
            let tableBodyData = [];
                title[datas.name] = i18n.translate(datas.name);

                  if (datas.name === "profile") {
                    header[datas.name] = { [datas.name]: headerBodyData(datas,false)};
                    body[i] = { [datas.name]: headerBodyData(datas,true) };
                  } else if (datas.name === "marketInfo") {
                    header[datas.name] = { [datas.name]: headerBodyData(datas,false)};
                    body[i] = { [datas.name]: headerBodyData(datas,true) };
                  } else {
                    let createData = datas.dataItems;
                    if (createData) {
                      let bodyColFirstentry = [], bodyColSecondtentry = [];
                      let headerColFirstentry = {}, headerColSecondtentry = {};
                      let tableTdcount;

                      let lenCheck = createData.length;
                      if (lenCheck <= 6) {
                        tableTdcount = Math.round(lenCheck);
                      } else {
                        tableTdcount = Math.round(lenCheck / 2);
                      }
                      createData.forEach((item, a) => {
                        let items = DATA_LISTS[item];
                        if (a < tableTdcount) {
                          headerColFirstentry = TableHeaderFn(
                            items,
                            headerColFirstentry,
                          );
                          bodyColFirstentry[0] = TableBodyDataFn(
                            instruments,
                            items,
                            bodyColFirstentry[0],
                            "right",template
                          );
                        } else if (a >= tableTdcount) {
                          headerColSecondtentry = TableHeaderFn(
                            items,
                            headerColSecondtentry,
                          );
                          bodyColSecondtentry[0] = TableBodyDataFn(
                            instruments,
                            items,
                            bodyColSecondtentry[0],
                            "right",template
                          );
                        }
                        tableBodyData = {
                          bodyColFirstentry,
                          bodyColSecondtentry,
                          headerColFirstentry,
                          headerColSecondtentry,
                        };
                      });
                    }
                    if (datas.name === 'performance') {
                      tableBody[0] = { [datas.name]: tableBodyData };
                    } else {
                      tableBody[i + 1] = { [datas.name]: tableBodyData };
                    }
                  }
          });
      break;
    case TOOL_TEMPLATE.victor:
          getdata = getdata[0].dataItems;
          if (getdata) {
            let tableTdcount;
            let lenCheck = getdata.length;
            if (lenCheck <= 6) {
              tableTdcount = Math.round(lenCheck);
            } else {
              tableTdcount = Math.round(lenCheck / 2);
            }

            getdata.forEach((item, i) => {
              let items = DATA_LISTS[item];
              if (i < tableTdcount) {
                header = TableHeaderFn(items, header);
                body[0] = TableBodyDataFn(instruments,items, body[0], "right",template);
              } else if (i >= tableTdcount) {
                header2 = TableHeaderFn(items, header2);
                body2[0] = TableBodyDataFn(instruments,items, body2[0], "right",template);
              }
            });
          }
      break;
    default:
      break;
  }

  return { header, body, title, header2, body2, tableBody };
};

function TickerDataLists() {
  const [{ selectedInstrument }] = useInstrument();
  const settings = useCompanySettings();
  const groupedData = settings.enabledDataItems?.groups;
  const template = useTemplateSetting();
  const format = useFormatSetting();
  const { header, body, title, header2, body2, tableBody } = createTableData({
    instrument: selectedInstrument,
    data: groupedData,
    template,
    format,
  });

  const caption = "";
  return (
    <>
      {template === TOOL_TEMPLATE.quadrata && (
        <div className="share-details-all" role="region">
          <div className="quadrata-share-flex-items">
            <table className="quadrata-profile-marketInfo-table" role="presentation">
              <tbody>
                <tr className="flex-tr">
                  {
                    <ProfileMarketTable
                      body={body}
                      header={header}
                      caption={caption}
                      title={title}
                    />
                  }
                </tr>
              </tbody>
            </table>
            {
              <OtherMarketInfoTable
                body={tableBody}
                header={header}
                caption={caption}
                title={title}
              />
            }
          </div>
        </div>
      )}
      {template === TOOL_TEMPLATE.victor && (
        <div className="share-details-all" id="all-datas">
          <table className="victor-inner-flex-data-table" role="table">
            <tbody>
              <tr className="flex-tr">
                <td className="flex-td">
                  {/* share-datas-table  secondarySectionArr */}
                  <TableData
                    className="share-datas-table"
                    design="table-victor"
                    hiddenHeader={false}
                    hiddenFooter={true}
                    body={body}
                    header={header}
                    theadChild={
                      <tr>
                        <th data-column="fieldName" scope="col">{i18n.translate("fieldName")}</th>
                        <th data-column="fieldValue" scope="col">{i18n.translate("fieldValue")}</th>
                      </tr>
                    }
                    theadProps={{
                      className: "sr-only"
                    }}
                    headerLeft={true}
                    caption={i18n.translate("captionVictorTable")}
                  ></TableData>
                </td>
                <td className="flex-td-none">
                  <p className="flex-td-none-line">&#160;</p>
                </td>
                <td className="flex-td">
                  <TableData
                    className="share-datas-table"
                    design="table-victor"
                    hiddenHeader={false}
                    hiddenFooter={true}
                    body={body2}
                    header={header2}
                    theadChild={
                      <tr>
                        <th data-column="fieldName" scope="col">{i18n.translate("fieldName")}</th>
                        <th data-column="fieldValue" scope="col">{i18n.translate("fieldValue")}</th>
                      </tr>
                    }
                    theadProps={{
                      className: "sr-only"
                    }}
                    headerLeft={true}
                    caption={i18n.translate("captionVictorTable")}
                  ></TableData>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

export default TickerDataLists;
